import { motion } from 'framer-motion';
import { Play } from 'iconoir-react';

interface PlayerVideoButtonProps {
  onClick?: () => void;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Animated play button component for video players
 */
const PlayerVideoButton: React.FC<PlayerVideoButtonProps> = ({ onClick, size = 'md' }) => {
  // Size mappings
  const sizeMap = {
    sm: { iconSize: 20, padding: 1.5 },
    md: { iconSize: 30, padding: 2 },
    lg: { iconSize: 40, padding: 3 },
  };

  const { iconSize, padding } = sizeMap[size];

  // Animation variants
  const buttonVariants = {
    initial: {
      scale: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    hover: {
      scale: 1.1,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    tap: {
      scale: 0.95,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  };

  return (
    <motion.div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        padding: `${padding * 0.25}rem`,
        cursor: 'pointer',
      }}
      initial="initial"
      whileHover="hover"
      whileTap="tap"
      variants={buttonVariants}
      onClick={onClick}
      transition={{ type: 'spring', stiffness: 400, damping: 17 }}
    >
      <Play width={iconSize} height={iconSize} color="white" />
    </motion.div>
  );
};

export default PlayerVideoButton;
